import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";

export default function DisputePanel() {
  const featured = [...topics].sort((a, b) => b.heat - a.heat)[0];

  return (
    <section className="rounded-lg border border-background-200 bg-background-100 px-4 py-10 md:px-8 md:py-12">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">争议焦点 vs 当事方回应</h2>
          <p className="mt-2 max-w-2xl text-sm text-foreground-600">
            把「大家在吵什么」和「当事方怎么说」分开列，先看清楚，再下判断。
          </p>
        </div>
        <Link
          to={`/topic/${featured.id}`}
          className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
        >
          查看该事件完整梳理
          <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
        </Link>
      </div>

      <p className="mt-6 rounded-md border-l-4 border-primary-400 bg-background-50 px-4 py-3 text-sm text-foreground-700">
        <span className="font-medium text-foreground-900">本案例：</span>
        {featured.title}
      </p>

      <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <div className="rounded-lg border border-background-200 bg-background-50 p-5">
          <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
            <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-100 text-primary-700">
              <i className="ri-scales-3-line text-base" aria-hidden="true"></i>
            </span>
            争议焦点
          </h3>
          <ul className="mt-4 space-y-4">
            {featured.disputes.map((item, index) => (
              <li key={item.point} className="flex gap-3">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-500 font-heading text-xs font-bold text-background-50">
                  {index + 1}
                </span>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900">{item.point}</h4>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">{item.detail}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-50 p-5">
          <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
            <span className="flex h-7 w-7 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
              <i className="ri-chat-quote-line text-base" aria-hidden="true"></i>
            </span>
            当事方回应
          </h3>
          <ul className="mt-4 space-y-4">
            {featured.responses.map((item) => (
              <li key={`${item.party}-${item.time}`} className="rounded-md border border-background-200 bg-background-100 p-4">
                <div className="flex items-center justify-between gap-3">
                  <span className="font-heading text-sm font-semibold text-foreground-950">{item.party}</span>
                  <span className="shrink-0 text-[11px] text-foreground-500">{item.time}</span>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">“{item.content}”</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}